import React from "react";
import { useParams } from "react-router";
import { useTranslation } from "react-i18next";
import FisheryDepartmentNotes from "./FisheryDepartmentNotes";
import { getFisheryDepartmentSalesNotesApi } from "api/registration";

const FisheryDepartmentSalesNote: React.FC = () => {
	const { id } = useParams();
	const { t } = useTranslation();

	return (
		<FisheryDepartmentNotes
			id={Number(id)}
			title={t("FisheryDepartmentSalesNotes")}
			apiMethod={getFisheryDepartmentSalesNotesApi}
		/>
	);
};

export default FisheryDepartmentSalesNote;
